// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Select } from '@imprivata-cloud/components';
import './ConsentStateSelection.less';
import type { ResidenceLocation } from '@api/types';

export interface ConsentStateSelectionProps {
  onSelect: (step: string) => void;
  onCancel: () => void;
  residenceLocations?: ResidenceLocation[]
}

const ConsentStateSelection = ({ onSelect: selectState, onCancel,  residenceLocations = [] }: ConsentStateSelectionProps) => {
  const { t } = useTranslation();

  const locationOptions = useMemo(() => {
     return residenceLocations.map((location) => ({
       value: location?.shortName,
       label: location?.displayName,
       titleLabel: location?.fullName,
     }));
   }, [residenceLocations]);

  const [residence, setResidence] = useState(locationOptions[0]?.value || '');

  return (
    <div className="consent-state-selection">
      <h2 className="consent-state-selection__title">{t('self-service.consent-screens.title')}</h2>
      <p className="consent-state-selection__description">{t('self-service.consent-screens.state-selection.text')}</p>
      <Select
        label={t('self-service.consent-screens.state-selection.state-picker-label')}
        aria-label="residence-dropdown"
        autoFocus
        defaultValue={locationOptions?.[0]}
        options={locationOptions}
        onChange={setResidence}
        className="consent-state-selection__select"
      />
      <div className="consent-state-selection__actions">
        <Button
          label={t('actions.continue')}
          type="primary"
          onClick={() => selectState(residence)}
          aria-label="continue-consent-button"
          className="consent-state-selection__continue-button"
        />
        <Button
          label={t('self-service.consent-screens.state-selection.resident-decline')}
          type="text"
          size="small"
          onClick={onCancel}
          aria-label="residence-picker-close-button"
          className="consent-state-selection__decline-button"
        />
      </div>
    </div>
  );
};

export default ConsentStateSelection;
